var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 8V13.8333H2.16667V8H0.5V13.8333C0.5 14.75 1.25 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V8H13.8333ZM8.83333 8.55833L10.9917 6.40833L12.1667 7.58333L8 11.75L3.83333 7.58333L5.00833 6.40833L7.16667 8.55833V0.5H8.83333V8.55833Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadV2);
export default __webpack_public_path__ + "static/media/icon-downloadV2.dbc3c9c880990276de8bc090f47a70b7.svg";
export { ForwardRef as ReactComponent };